.cancel-survey {
  color: var(--sc-color-gray-900);

  &__abort-link {
    color: var(--sc-color-gray-500);
  }
}
